import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type DateInputProps, DateInput } from '../DateInput';

type FormDateInputProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  DateInputProps;

function FormDateInput<TFieldValues extends FieldValues = FieldValues>(
  props: FormDateInputProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <DateInput
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText}
      required={Boolean(props.rules?.required ?? props.required)}
      ref={ref}
      onChange={(value) => {
        field.onChange(value);
        props.onChange?.(value);
      }}
    />
  );
}

export type { FormDateInputProps };
export { FormDateInput };
